import config from './config';
import userState from './userState';
import UserViewModel from './userModel';
import {
  renderAuthElementsInHeader
} from './ui';

/**
 * Сохраняет модель пользователя в LocalStorage
 * @private
 * @param { UserViewModel } user
 */
const saveUserViewModelToLocalStorage = (user) => {
  const userJsonString = JSON.stringify(user);
  localStorage.setItem(config.keys.USER_DATA_KEY, userJsonString);
};

/**
 * Создает модель пользователя
 * @public
 * @param ramblerIdUserData
 * @returns {UserViewModel}
 */
export const userViewModelBuilder = (ramblerIdUserData) => {
  return new UserViewModel(ramblerIdUserData);
};

/**
 * Сохраняет данные пользователя в localStorage
 * @public
 * @param _data
 */
export const saveUserData = (_data) => {
  // Создаем нашу модель пользователя
  const userViewModel = userViewModelBuilder(_data);
  // Сохраняем модель пользователя в localStorage
  saveUserViewModelToLocalStorage(userViewModel);
  // Вернем пользователя
  return userViewModel;
};


/**
 * Обновляет стейт пользователя
 * @public
 * @param userViewModel - модель пользователя
 * @param authorized - авторизован?
 */
export const updateState = (userViewModel, authorized) => {
  if (userViewModel) {
    userState.user = userViewModel;
  }
  userState.isAuthorized = authorized;
  // Перерисуем пользователя в шапке
  renderAuthElementsInHeader(userState);
};

/**
 * Обновляет статус подписки в стейте пользователя
 * @public
 * @returns { Boolean }
 */
export const updateSubscriptionInUserState = (hasSubscription) => {
  if (userState.hasSubscription !== hasSubscription) {
    userState.hasSubscription = hasSubscription;
    // Перерисуем пользователя в шапке
    renderAuthElementsInHeader(userState);
  }
};

/**
 * Получает сохраненную модель пользователя из LocalStorage
 * @public
 * @returns {*}
 */
export const getUserViewModelFromLocalStorage = () => {
  const userJsonString = localStorage.getItem(config.keys.USER_DATA_KEY);
  let userViewModel = null;
  if (userJsonString) {
    userViewModel = JSON.parse(userJsonString);
  }
  return userViewModel;
};



// WEBPACK FOOTER //
// ./daily/assets/id/userApi.js